import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import styles from './CampaignStatus.module.css';
import { CampaignStatusData } from '../../../types';

interface CampaignStatusProps {
  data: CampaignStatusData;
}

interface ChartData {
  name: string;
  raised: number;
  remaining: number;
}

const CampaignStatus = ({ data }: CampaignStatusProps) => {
  const { weekly, raised, target } = data;
  const progress = (raised / target) * 100;
  const chartData: ChartData[] = [
    {
      name: 'Campaign Progress',
      raised: raised,
      remaining: target - raised,
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.summary}>
        <p>Raised this week: <strong>${weekly.toLocaleString()}</strong></p>
        <p>Progress: <strong>{progress.toFixed(0)}%</strong> of ${target.toLocaleString()}</p>
      </div>
      <div role="img" aria-label={`Campaign progress: $${raised.toLocaleString()} raised of $${target.toLocaleString()} target, ${progress.toFixed(0)}% complete`}>
        <ResponsiveContainer width="100%" height={40}>
          <BarChart layout="vertical" data={chartData} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
            <XAxis type="number" hide domain={[0, target]} />
            <YAxis type="category" dataKey="name" hide />
            <Tooltip formatter={(value) => `$${(value as number).toLocaleString()}`} />
            <Bar dataKey="raised" stackId="a" fill="#82ca9d" name="Raised" />
            <Bar dataKey="remaining" stackId="a" fill="#e0e0e0" name="Remaining" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CampaignStatus;
